import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

        this.$navItems = this.$('item');
        this.$backgrounds = this.$('background');
        this.$images = this.$('image');
        this.$shadows = this.$('shadow');
        this.$bottles = this.$('bottle');
        this.$backgroundsWrap = this.$('backgroundsWrap')[0];
        this.$imagesWrap = this.$('imagesWrap')[0];

        this.events = {
            mouseenter: {
                item: 'enter'
            },
            mouseleave: {
                item: 'leave'
            }
        }
    }

    init() {
        this.oldBackground = null;
        this.oldImage = null;
        this.oldShadow = null;

        this.index = 0;
    }

    enter(e) {
        if(window.isMobile) return;
        let id = e.currentTarget.getAttribute('data-id');

        this.$backgrounds.forEach((background,index) => {
            if(background.getAttribute('data-id') == id) {
                this.displayBackground(background);
                this.index = index;
            }
        });

        this.$images.forEach((image,index) => {
            if(image.getAttribute('data-id') == id) {
                this.displayImage(image);
            }
        });

        this.$bottles.forEach((bottle,index) => {
            if(bottle.getAttribute('data-id') == id) {
                bottle.classList.add('is-active');
            }
        });
        
        this.$shadows.forEach((shadow,index) => {
            if(shadow.getAttribute('data-id') == id) {
                shadow.classList.add('is-active');
            }
        });
    }

    leave() {
        if(window.isMobile) return;
        
        gsap.delayedCall(0.6,() => {
            if(this.oldBackground != null) {
                this.oldBackground.classList.remove('is-active');
            }
            if(this.oldImage != null) {
                this.oldImage.classList.remove('is-active');
            }
        });

        this.$bottles.forEach((bottle,index) => {
            if(bottle.classList.contains('is-active')) {
                bottle.classList.remove('is-active');
            }
        });
        this.$shadows.forEach((shadow,index) => {
            if(shadow.classList.contains('is-active')) {
                shadow.classList.remove('is-active');
            }
        });

        this.index = -1;

        gsap.delayedCall(0.2,() => {
            if(this.index == -1) {
                if(this.oldBackground != null) {
                    this.oldBackground.classList.remove('is-active');
                }
                if(this.oldImage != null) {
                    this.oldImage.classList.remove('is-active');
                }
            }
        });
    }

    displayBackground(background) {
        let clonedBackground = background.cloneNode(true);
        this.$backgroundsWrap.appendChild(clonedBackground);

        gsap.delayedCall(0.02,() => {
            clonedBackground.classList.add('is-active');
            
            if(this.oldBackground != null) {
                gsap.delayedCall(0.6,() => {
                    this.$backgroundsWrap.removeChild(this.oldBackground);
                    this.oldBackground = clonedBackground;
                })
            } else {
                this.oldBackground = clonedBackground;
            }
        })
    }
    
    displayImage(image) {
        let clonedImage = image.cloneNode(true);
        this.$imagesWrap.appendChild(clonedImage);

        gsap.delayedCall(0.02,() => {
            clonedImage.classList.add('is-active');
            
            if(this.oldImage != null) {
                gsap.delayedCall(0.6,() => {
                    this.$imagesWrap.removeChild(this.oldImage);
                    this.oldImage = clonedImage;
                })
            } else {
                this.oldImage = clonedImage;
            }
        })
    }

    close() {
        gsap.delayedCall(1,() => {
            if(this.oldBackground != null) {
                this.oldBackground.classList.remove('is-active');
            }
            if(this.oldImage != null) {
                this.oldImage.classList.remove('is-active');
            }
        });
        
        this.$bottles.forEach((bottle,index) => {
            bottle.classList.remove('is-active');
        });
        this.$shadows.forEach((shadow,index) => {
            shadow.classList.remove('is-active');
        });
    }
}
